import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ProductsProvider } from "./contexts/ProductsContext";

//import pages
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Collections from "./pages/Collections";
import ProductPage from "./pages/ProductPage";

// Admin pages are lazy-loaded so heic2any (and the rest of the admin
// code) only ships to visitors who actually visit /admin.
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminProducts = lazy(() => import("./pages/AdminProducts"));
const AdminProductNew = lazy(() => import("./pages/AdminProductNew"));
const AdminProductEdit = lazy(() => import("./pages/AdminProductEdit"));

const AdminLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-cream text-stone-400">
    Loading…
  </div>
);

const App = () => {
  return (
    <LanguageProvider>
      <ProductsProvider>
        <div className="overflow-hidden">
          <Router>
            <Suspense fallback={<AdminLoading />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/product/:productId" element={<ProductPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminProducts />} />
                <Route
                  path="/admin/products/new"
                  element={<AdminProductNew />}
                />
                <Route
                  path="/admin/products/:id/edit"
                  element={<AdminProductEdit />}
                />
              </Routes>
            </Suspense>
          </Router>
        </div>
      </ProductsProvider>
    </LanguageProvider>
  );
};

export default App;
